import React from 'react'
import { colors } from '../../../consts'
import { SeasonSelectorType } from '../../../../Constants/season'
import { createYearDropdownList } from '../../../../Utils'
import { CustomSelect } from '../..'

type YearSelectProps = {
  current: number
  onChangeYear: (year: number) => void
  seasonSelectorType: SeasonSelectorType
  requireAllYear?: boolean
  color?: string
}

export const YearSelect: React.FC<React.PropsWithChildren<YearSelectProps>> = ({
  current,
  onChangeYear,
  seasonSelectorType,
  color = colors.yellow,
  requireAllYear = false,
}) => {
  const yearList = createYearDropdownList(seasonSelectorType, requireAllYear, -1)

  const onChange = (option: string) => {
    if (option === 'All Years') {
      onChangeYear && onChangeYear(0)
    } else {
      const v = parseInt(option)
      onChangeYear && onChangeYear(v)
    }
  }

  const getValue = () => {
    if (current === 0) {
      return 'All Years'
    }
    return current.toString()
  }

  return (
    <CustomSelect
      options={yearList.map((yr) => yr.label)}
      value={getValue()}
      onChange={onChange}
      id="year-select"
      ariaLabel="Year select"
    />
  )
}
